<swiper [config]="responsiveNoOverflowConfig" (swiper)="onResourcesSwiper($event)" class="w-100">
    <ng-template swiperSlide *ngIf="!loadedPosts">
        <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
            'height': '300px',
            'width': '100%'
        }"></ngx-skeleton-loader>
    </ng-template>
    <ng-template swiperSlide *ngIf="!loadedPosts">
        <ngx-skeleton-loader count="1" animation="pulse" [theme]="{ 
            'height': '300px',
            'width': '100%'
        }"></ngx-skeleton-loader>
    </ng-template>
    <ng-template swiperSlide *ngFor="let post of posts">
        <app-post-item id="{{ post.id }}" image="{{ post.image }}" title="{{ post.title }}" slug="{{ post.slug }}"
            summary="{{ post.summary }}" date="{{ post.date }}" [tagged]="post.tagged" swiperEnabled="true">
        </app-post-item>
    </ng-template>
</swiper>